// /opt/ptg01-v1/front-simulation/lib/fetchAdmin.ts
// Helper fetch authentifié — cookie httpOnly `nx_token` envoyé automatiquement via
// `credentials: 'include'`. Plus de fallback Bearer : la migration C2 est finalisée,
// le backend n'accepte que le cookie.
//
// CSRF double-submit : le cookie `nx_csrf` (non-httpOnly) est lu en JS et renvoyé
// comme header `X-CSRF-Token`. Le backend valide que cookie === header sur les
// méthodes unsafe.
import type { ApiResponse } from '@nexvia/types';

function readCookie(name: string): string | null {
    if (typeof document === 'undefined') return null;
    const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]+)`));
    return match ? decodeURIComponent(match[1]) : null;
}

export async function fetchAdmin(url: string, options?: RequestInit): Promise<Response> {
    const csrf = readCookie('nx_csrf');
    const headers: Record<string, string> = {
        ...(options?.headers as Record<string, string> || {}),
    };
    if (csrf) headers['X-CSRF-Token'] = csrf;
    return fetch(url, {
        ...options,
        headers,
        credentials: 'include',   // 🔒 envoie le cookie httpOnly nx_token
    });
}

/**
 * Version typée qui parse directement la réponse JSON en ApiResponse<T>.
 * Usage :
 *   const res = await fetchAdminJson<Consultant[]>('/api/admin/consultants');
 *   if (res.success) { res.data.map(...) } else { console.error(res.message) }
 */
export async function fetchAdminJson<T = unknown>(url: string, options?: RequestInit): Promise<ApiResponse<T>> {
    try {
        const res = await fetchAdmin(url, options);
        const json = (await res.json()) as ApiResponse<T>;
        return json;
    } catch (e) {
        return {
            success: false,
            message: e instanceof Error ? e.message : 'Erreur réseau',
            error: 'network',
        };
    }
}
